<template>
  <div class="main-wrapper">
    <el-table :data="items" style="width: 100%">
      <el-table-column prop="orderNo" label="订单号" width="180"></el-table-column>
      <el-table-column label="订单类型" width="150">
        <template #default="scope">
          {{ getResourceType(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="resourceTitle" label="名称"></el-table-column>
      <el-table-column label="金额" width="150">
        <template #default="scope">￥{{ scope.row.amount.toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="支付方式" width="150">
        <template #default="scope">
          {{ getChannel(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="createdDate" label="支付时间" align="center" width="150"></el-table-column>
      <el-table-column align="center">
        <template #default="scope">
          <el-link
            type="primary"
            style="margin-right: 10px"
            :underline="false"
            icon="el-icon-download"
            v-if="isDownload(scope.row)"
            @click.prevent="btnDownloadClick(scope.row)"
          >
            下载
          </el-link>
          <el-link v-if="isUrl(scope.row)" :href="getUrl(scope.row)" :underline="false" target="_blank" type="primary">
            <i class="iconfont icon-externallink"></i>
            商品地址
          </el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts">
import api from '@/api/my/orders';
import { IOrder } from '@/types/models';
import { defineComponent } from 'vue';

interface IState {
  items: IOrder[];
}

export default defineComponent({
  data() {
    return {
      items: [],
    } as IState;
  },
  methods: {
    getResourceType(item: IOrder) {
      if (item.resourceType === 'Extension') return '插件';
      if (item.resourceType === 'Theme') return '模板';
      if (item.resourceType === 'Starter') return '网站云入门版';
      if (item.resourceType === 'Standard') return '网站云标准版';
      if (item.resourceType === 'Professional') return '网站云专业版';
      return '';
    },

    getChannel(item: IOrder) {
      if (item.channel === 'AliPay') return '支付宝';
      if (item.channel === 'WxPay') return '微信支付';
      return '';
    },

    isDownload(item: IOrder) {
      if (item.resourceType === 'Theme' || item.resourceType === 'Extension') {
        return true;
      }
      return false;
    },

    isUrl(item: IOrder) {
      if (item.resourceType === 'Theme' || item.resourceType === 'Extension') {
        return true;
      }
      return false;
    },

    getUrl(item: IOrder) {
      if (item.resourceType === 'Theme') {
        return `/templates/template.html?resourceId=${item.resourceId}`;
      }
      if (item.resourceType === 'Extension') {
        return `/plugins/plugin.html?resourceId=${item.resourceId}`;
      }
      return '#';
    },

    btnDownloadClick(item: IOrder) {
      api.download({
        resourceType: item.resourceType,
        resourceId: item.resourceId,
      }, (res) => {
        if (!res) return;
        window.open(res.value);
      });
    },
  },
  mounted() {
    api.getItems((res) => {
      if (!res) return;
      this.items = res.items;
    });
  },
});
</script>
